// ============================================================================
// chatText.ts — эвристика текста сообщения чата (SSoT).
//
// Детерминированная эвристика: сообщение содержит разметку Markdown →
// рендерим ПОЛНОЦЕННЫЙ MD (MarkdownView + HydraLink — единый SSoT-механизм
// ссылок платформы); простой текст — как есть (RichText). Ложных срабатываний
// на обычном тексте нет: триггеры — заголовки/код/списки/цитаты/таблицы/
// жирный/зачёркнутый/ссылки-маркдаун в начале строк.
// ============================================================================

const MARKDOWN_RE = /(^|\n)\s*(#{1,6}\s|```|[-*+]\s|\d+\.\s|>\s|~~|\*\*|__|\||\[[^\]]+\]\((?:https?:|doc:|object:|\/))/m;

export function looksLikeMarkdown(text: string): boolean {
  return MARKDOWN_RE.test(String(text || ''));
}
